import {NoteViewModel} from '../../note/models/views/note-view.model';
import {DisabilityCertificationModel} from './disability-certification.model';
import {PlateConfigurationModel} from './plate-configuration.model';
import { VehicleOwnershipModel } from './vehicle-ownership.model';

export class PlateModel {
    constructor() {
        this.notes = new Array<NoteViewModel>();
    }

    public id: number;
    public plateNumber: string;
    public personalizedPlateReason: string;
    public plateConfigurationId: number;

    public plateStatusChangeDate: Date;
    public plateIssueDate: Date;
    public isRenewal: boolean;
    public isInitial: boolean;
    public isTransfer: boolean;
    public isTabReplacement: boolean;
    public isReplace: boolean;
    public isDisabled: boolean;
    private _isPersonalized: boolean;
    get isPersonalized(): boolean {
        return this._isPersonalized;
    }
    set isPersonalized(thisIsPersonalized: boolean) {
        this._isPersonalized = thisIsPersonalized;
    }
    public notes: NoteViewModel[];
    public originalPlateStatusTypeId: number;
    public plateStatusTypeId: number;
    public canManualUnReserve: boolean;
    public manualUnReserveMessage: string;
    public plateReplacementReasonTypeId: number;

    public plateConfiguration: PlateConfigurationModel;

    public plateAction: string;
    public plateToTransfer: string;
    public ownershipToTransferPlate: VehicleOwnershipModel;
    public previouslyPrintedPlateNumber: string;

    public setValues(targetPlate: PlateModel, sourcePlate: PlateModel) {
        targetPlate.id = sourcePlate.id;
        targetPlate.plateConfigurationId = sourcePlate.plateConfigurationId;
        targetPlate.plateConfiguration = sourcePlate.plateConfiguration;
        targetPlate.plateStatusTypeId = sourcePlate.plateStatusTypeId;
        targetPlate.plateNumber = sourcePlate.plateNumber;
        targetPlate.plateStatusChangeDate = sourcePlate.plateStatusChangeDate;
        targetPlate.personalizedPlateReason = sourcePlate.personalizedPlateReason;
        targetPlate.plateIssueDate = sourcePlate.plateIssueDate;
        targetPlate.canManualUnReserve = sourcePlate.canManualUnReserve;
        targetPlate.manualUnReserveMessage = sourcePlate.manualUnReserveMessage;
    }

    public resetValues(targetPlate: PlateModel) {
        targetPlate.id = 0;
        targetPlate.plateConfigurationId = 0;
        targetPlate.plateConfiguration = null;
        targetPlate.plateStatusTypeId = 0;
        targetPlate.plateNumber = null;
        targetPlate.plateStatusChangeDate = new Date();
        targetPlate.personalizedPlateReason = null;
        targetPlate.plateIssueDate = new Date();
        targetPlate.canManualUnReserve = false;
        targetPlate.manualUnReserveMessage = null;
        targetPlate.plateConfiguration = new PlateConfigurationModel();
        targetPlate.plateConfiguration.plateTypeId = 0;
    }
}
